import { pluralizeWord } from './pluralizeWord';
const pluralizeWordVariants = ['бонус', 'бонуса', 'бонусов'];
export const formatBonus = bonus => new Intl.NumberFormat('ru-RU').format(bonus) + ' ' + pluralizeWord(bonus, pluralizeWordVariants);